import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';
import { boleto } from 'boleto-brasileiro-validator';
import { isNullOrUndefined } from 'util';

export class ControlValidator {
  static boletoValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!isNullOrUndefined(control.value)) {
        if (!boleto(control.value)) {
          return { invalidBoleto: true };
        }
      }
      return null;
    };
  }
}
